/* Tirvela mega header — hover delays + mobile drawer */
(function () {
  if (window.__trvMhInit) return;
  window.__trvMhInit = true;

  function init() {
    const headers = document.querySelectorAll('[data-trv-mh]');
    headers.forEach(setupHeader);
  }

  function setupHeader(header) {
    if (header.__trvMhReady) return;
    header.__trvMhReady = true;

    // Hover with small delays to prevent flicker
    const items = header.querySelectorAll('[data-trv-mh-item]');
    items.forEach(item => {
      let openTimer, closeTimer;
      const trigger = item.querySelector('[data-trv-mh-trigger]');
      const open = () => {
        clearTimeout(closeTimer);
        openTimer = setTimeout(() => {
          item.classList.add('is-open');
          if (trigger) trigger.setAttribute('aria-expanded', 'true');
        }, 80);
      };
      const close = () => {
        clearTimeout(openTimer);
        closeTimer = setTimeout(() => {
          item.classList.remove('is-open');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }, 180);
      };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      if (trigger) {
        trigger.addEventListener('focus', () => item.classList.add('is-open'));
      }
    });

    // Close mega when clicking outside or pressing Escape
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') items.forEach(i => i.classList.remove('is-open'));
    });

    // Mobile drawer
    const burger = header.querySelector('[data-trv-mh-burger]');
    const drawer = header.querySelector('[data-trv-mh-drawer]');
    const close = header.querySelector('[data-trv-mh-close]');

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (burger && drawer) burger.addEventListener('click', openDrawer);
    if (close && drawer) close.addEventListener('click', closeDrawer);
    if (drawer) {
      drawer.addEventListener('click', e => { if (e.target === drawer) closeDrawer(); });
    }
  }

  // Cart count refresh on add (Shopify standard event)
  function updateCartCount() {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      document.querySelectorAll('[data-trv-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
    }).catch(() => {});
  }
  document.addEventListener('cart:updated', updateCartCount);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
